/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import * as _ from 'underscore';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import classnames from 'classnames';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputTextRule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			rule: this.props.rule
		};

		this.deleteRule = this.deleteRule.bind(this);
		this.updateRule = this.updateRule.bind(this);
		this.changeBehavior = this.changeBehavior.bind(this);

	}

	deleteRule() {
		this.props.textRuleHandler('delete', this.props.ruleId);
	}

	updateRule(e) {
		let field = e.currentTarget.dataset.field,
			newRule = _.clone(this.state.rule),
			toggleState = (e.currentTarget.dataset.togglestate) ? e.currentTarget.dataset.togglestate : 'false';

		if (field === 'title' || field === 'body') {
			if (toggleState === 'false') {
				if (newRule.fields.indexOf(field) === -1) {
					newRule.fields.push(field);
				}
			} else {
				newRule.fields = [];
				if (field === 'title') {
					newRule.fields.push('body');
				} else {
					newRule.fields.push('title');
				}
			}
		}

		if (field === 'case') {
			if (toggleState === 'false') {
				newRule['case'] = true;
			} else {
				newRule['case'] = false;
			}
		}

		if (field === 'find') {
			if (toggleState === 'false') {
				newRule.find = 'whole';
			} else {
				newRule.find = 'any';
			}
		}

		if (field === 'search' || field === 'replace') {
			newRule[field] = event.target.value;
		}

		this.setState({
			rule: newRule
		});

		this.props.textRuleHandler('update', this.props.ruleId, newRule);
	}

	changeBehavior(e) {
		let newRule = _.clone(this.state.rule);

		newRule.action = e.target.value;

		this.setState({
			rule: newRule
		});

		this.props.textRuleHandler('update', this.props.ruleId, newRule);

	}

	render() {
		let caseSensitive = (this.state.rule['case']) ? true : false,
			searchType = (this.state.rule.find === 'whole') ? true : false,
			searchTitle = (this.state.rule.fields && this.state.rule.fields.indexOf('title') !== -1) ? true : false,
			searchBody = (this.state.rule.fields && this.state.rule.fields.indexOf('body') !== -1) ? true : false,
			replaceField = null,
			replaceOptions = [
				{value: 'replace', label: 'Replace'},
				{value: 'remove', label: 'Remove'}
			],
			action = this.state.rule.action,
			ruleError = null,
			ruleClass = classnames('find-replace-rule',{
				'error': (ruleError !== null) ? true : false
			}),
			ruleSearch = (this.state.rule && this.state.rule.search) ? this.state.rule.search : '';

		if (action === undefined || action === '') {
			if (this.state.rule.replace !== '') {
				action = "replace";
			} else {
				action = "remove";
			}
		}

		ruleError = (
			<ErrorModule
				app={this.props.app}
				keys={['INPUT_CREATE', 'INPUT_UPDATE']}
				render={(state) => {
					return (
						<FieldError field="rules" options={{index: this.props.ruleId}} errors={state.errors}/>
					);
				}}/>
		);

		if (action === 'replace') {
			let replaceRule = (this.state.rule && this.state.rule.replace) ? this.state.rule.replace : '';

			replaceField = <UncontrolledTextInput
								defaultValue={replaceRule}
								className="text-input small"
								onChange={this.updateRule}
								data-field="replace"
								placeholder="Replace with text"/>;
		}

		return (
			<div>
				{ruleError}
				<div className={ruleClass}>
					<div className="remove-rule" onClick={this.deleteRule} role="button" aria-label="remove rule">
						<i className="fa fa-times-circle"></i>
					</div>
					<div className="text-search">
						<StyledSelect options={replaceOptions}
										value={action}
										selectClass="small"
										onChange={this.changeBehavior} />
						<UncontrolledTextInput
							defaultValue={ruleSearch}
							className="text-input small"
							onChange={this.updateRule}
							data-field="search"
							placeholder="Search for text"/>
						{replaceField}
					</div>
					<div className="rule-options">
						<div className="rule-option">
							<Toggle active={caseSensitive}
									activeLabel="case sensitive"
									inactiveLabel="case insensitive"
									linkedField="case"
									callback={this.updateRule}
									labelPlacement="right" />
						</div>
						<div className="rule-option">
							<Toggle active={searchType}
									activeLabel="match whole word"
									inactiveLabel="match anywhere"
									linkedField="find"
									callback={this.updateRule}
									labelPlacement="right" />
						</div>
						<div className="rule-option">
							<Toggle active={searchTitle}
									activeLabel="search title"
									inactiveLabel="don't search title"
									linkedField="title"
									callback={this.updateRule}
									labelPlacement="right" />
						</div>
						<div className="rule-option">
							<Toggle active={searchBody}
									activeLabel="search body"
									inactiveLabel="don't search body"
									linkedField="body"
									callback={this.updateRule}
									labelPlacement="right" />
						</div>
					</div>
				</div>
			</div>
		);
	}

};

InputTextRule.displayName = "InputTextRule";

InputTextRule.propTypes = {
	ruleId: PropTypes.number,
	rule: PropTypes.object,
	textRuleHandler: PropTypes.func,
	errors: PropTypes.object
};

InputTextRule.defaultProps = {
	ruleId: 0,
	rule: {},
	errors: null
};

export default ComponentWithContext(InputTextRule);
